module.exports = __webpack_public_path__ + "assets/img/icon-shipin-03acbb51.png";